import { type RouteRecordRaw } from 'vue-router'

import { eModules } from '@/constants'
import Layout from '@/layout/index.vue'

export const factoryDashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    components: {
      default: () => import('@/modules/module-factory-dashboard/views/dashboard/index.vue'),
      navbar: () => import('@/modules/module-factory-dashboard/views/navbar/index.vue'),
    },
    meta: {
      title: 'Dashboard',
      icon: 'Dashboard',
      affix: true,
      allowedModules: [eModules.FACTORY_DASHBOARD],
      layout: Layout,
    },
    children: [
      {
        path: '/dashboard/tree-view/:id',
        components: {
          default: () => import('@/modules/module-factory-dashboard/views/dashboard/index.vue'),
          navbar: () => import('@/modules/module-factory-dashboard/views/navbar/index.vue'),
        },
        name: 'dashboard-tree-view',
        meta: {
          title: 'Dashboard',
          icon: 'Dashboard',
          affix: true,
          allowedModules: [eModules.FACTORY_DASHBOARD],
        },
      },
      {
        path: '/dashboard/entity/:id',
        components: {
          default: () => import('@/modules/module-factory-dashboard/views/dashboard/index.vue'),
          navbar: () => import('@/modules/module-factory-dashboard/views/navbar/index.vue'),
        },
        name: 'dashboard-entity',
        meta: {
          title: 'Dashboard',
          icon: 'Dashboard',
          affix: true,
          allowedModules: [eModules.FACTORY_DASHBOARD],
        },
      },
      {
        path: '/dashboard/entity/:id/detail',
        components: {
          default: () => import('@/modules/module-factory-dashboard/views/dashboard/index.vue'),
          navbar: () => import('@/modules/module-factory-dashboard/views/navbar/index.vue'),
        },
        name: 'dashboard-entity-detail',
        meta: {
          title: 'Dashboard',
          icon: 'Dashboard',
          affix: true,
          allowedModules: [eModules.FACTORY_DASHBOARD],
        },
      },
    ],
  },
]
